import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import makeServer from "./server";
import { Provider } from "react-redux";
import { store } from "./store";
import "flowbite";

// Silenzia ResizeObserver loop warning (innocuo, causato da Chart.js)
const origError = window.onerror;
window.onerror = (msg, ...args) => {
  if (typeof msg === "string" && msg.includes("ResizeObserver")) return true;
  return origError ? (origError as any)(msg, ...args) : false;
};
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver")) e.stopImmediatePropagation();
});

const { REACT_APP_SERVER_ENV } = process.env;
if (REACT_APP_SERVER_ENV === "LOCAL") {
  makeServer();
}
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
